module.exports = __webpack_public_path__ + "img/delete-red.d4c469d6.svg";